import GetProductsRequestModelBase from '../_generated/modelBases/get-products-request-model-base';

export default class GetProductsRequestModel extends GetProductsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
